import React, {FC, ReactNode} from 'react';

import {IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {SettingsSearchDropdownItemBaseProps} from './settingsSearchCommonTypes';
import {SettingsSearchDropdownGenericItem} from './settingsSearchDropdownGenericItem';

/*
 * Props.
 */

interface SettingsSearchDropdownPreferenceItemProps extends SettingsSearchDropdownItemBaseProps {
  isCompanyPreference?: boolean;
  name: string;
  description: ReactNode;
  iconName?: IconName;
}

/*
 * Component.
 */

export const SettingsSearchDropdownPreferenceItem: FC<SettingsSearchDropdownPreferenceItemProps> = (
  props,
) => (
  <SettingsSearchDropdownGenericItem
    label={props.name}
    onSelect={props.onSelect}
    iconName={props.iconName || 'preferencesSmall'}
    title={props.name}
    subtitle={props.description}
  />
);
